/**
 * AnimatedNumber — counts from 0 to `value` when it scrolls into view.
 * Pure CSS / RAF, no extra dependency on framer-motion's complex hooks.
 */
import React, { useEffect, useRef, useState } from "react";

export default function AnimatedNumber({
  value = 0,
  duration = 900,
  format = (v) => Math.round(v).toLocaleString("de-DE"),
  className = "",
  ...rest
}) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(eased * value);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.25 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value, duration]);

  return (
    <span ref={ref} className={className} {...rest}>
      {format(display)}
    </span>
  );
}
